import axios from "../utils/axios.wrapper";

export const getStores = async () => {
  const { data } = await axios.get("/shop/active");
  return data.items || data;
};

export const getActiveStores = async () => {
  const { data } = await axios.get("/shop/active");
  return data.items || data;
};

export const getInactiveStores = async () => {
  const { data } = await axios.get("/shop/inactive");
  return data.items || data;
};

export const getStoreById = async (id) => {
  const { data } = await axios.get(`/shop/${id}`);
  return data;
};

export const getStoreByName = async (name) => {
  const { data } = await axios.get(`/shop/name/${name}`);
  return data;
};

export const getStoreByCode = async (code) => {
  const { data } = await axios.get(`/shop/code/${code}`);
  return data;
};

export const getStoresByType = async (typeId) => {
  const { data } = await axios.get(`/shop/type/${typeId}`);
  return data.items || data;
};

export const createStore = async (store) => {
  const { data } = await axios.post("/shop/create", store);
  return data;
};

export const updateStore = async (id, store) => {
  const { data } = await axios.put(`/shop/${id}`, store);
  return data;
};

export const deleteStore = async (id) => {
  const { data } = await axios.delete(`/shop/${id}`);
  return data;
};

export const hardDeleteStore = async (id) => {
  const { data } = await axios.delete(`/shop/hard/${id}`);
  return data;
};

export const importStores = async (file) => {
  const formData = new FormData();
  formData.append('File', file);
  const { data } = await axios.post("/shop/import", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const downloadStoreTemplate = async () => {
  const response = await axios.get("/shop/download-template", {
    responseType: 'blob',
  });
  return response;
};

export const storeService = {
  getStores,
  getActiveStores,
  getInactiveStores,
  getStoreById,
  getStoreByName,
  getStoreByCode,
  getStoresByType,
  createStore,
  updateStore,
  deleteStore,
  hardDeleteStore,
  importStores,
  downloadStoreTemplate,
};
